import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import {
  MappedQuoteItem,
  useGetOrderHistory,
} from "../../queries/useGetOrderHistory";
import {
  DateDisplay,
  DEALER_DATE_TIME,
} from "../../ui/DateDisplay/DateDisplay";
import { Placeholder } from "../../ui/Placeholder";
import { PriceDisplay } from "../../ui/PriceDisplay/PriceDisplay";
import { removeHostFromUrl } from "../../util/removeHostFromUrl";
import { TableHeader } from "../ColumnSort/TableHeader";
import { NoData } from "../NoData/NoData";

const placehoders: MappedQuoteItem[] = [];

for (let i = 0; i < 3; i++) {
  placehoders.push({} as MappedQuoteItem);
}

export const QuotesTable: FunctionComponent = () => {
  const { data = placehoders, isLoading } = useGetOrderHistory();
  const { t } = useTranslation();
  return (
    <>
      <table className="border-collapse table-auto w-full text-xs">
        <thead>
          <tr className="border-b-2 border-edge align-bottom">
            <TableHeader
              className="text-left"
              field="type"
              tableName="quoteReport"
            />
            <TableHeader
              className="text-right"
              field="quoteNumber"
              tableName="quoteReport"
            />
            <TableHeader
              className="text-left"
              field="createdBy"
              tableName="quoteReport"
            />
            <TableHeader
              className="text-left"
              field="customerName"
              tableName="quoteReport"
            />
            <TableHeader
              className="text-left"
              field="customerEmail"
              tableName="quoteReport"
            />
            <TableHeader
              className="text-left"
              field="customerPhone"
              tableName="quoteReport"
            />
            <TableHeader
              className="text-left"
              field="dateCreated"
              tableName="quoteReport"
            />
            <TableHeader
              className="text-right"
              field="quoteTotal"
              tableName="quoteReport"
            />
            <TableHeader
              className="text-left"
              field="customerNotes"
              tableName="quoteReport"
            />
            <TableHeader
              className="text-left"
              field="orderPrinted"
              tableName="quoteReport"
            />
            <TableHeader
              className="text-left"
              field="priceMatch"
              tableName="quoteReport"
            />
            <TableHeader
              className="text-left"
              field="status"
              tableName="quoteReport"
            />
            <TableHeader
              className="text-left"
              field="viewQuotes"
              tableName="quoteReport"
            />
          </tr>
        </thead>
        <tbody>
          {data.map(
            (
              {
                createdBy,
                customerEmail,
                customerName,
                customerNotes,
                customerPhone,
                dateCreated,
                orderPrinted,
                priceMatch,
                quoteNumber,
                quoteTotal,
                status,
                type,
                viewQuotes,
              },
              key
            ) => (
              <tr
                className="border-b border-edge align-top"
                key={`${quoteNumber}-${key}`}
              >
                <td className="px-2 py-1 w-4">
                  <Placeholder loading={isLoading}>{type}</Placeholder>
                </td>
                <td className="px-2 py-1 text-right">
                  <Placeholder loading={isLoading}>
                    <a
                      className="underline text-primary"
                      href={removeHostFromUrl(viewQuotes || "")}
                      rel="noreferrer"
                      target="_blank"
                    >
                      {quoteNumber}
                    </a>
                  </Placeholder>
                </td>
                <td className="px-2 py-1">
                  <Placeholder loading={isLoading}>{createdBy}</Placeholder>
                </td>
                <td className="px-2 py-1">
                  <Placeholder loading={isLoading}>{customerName}</Placeholder>
                </td>
                <td className="px-2 py-1">
                  <Placeholder loading={isLoading}>{customerEmail}</Placeholder>
                </td>
                <td className="px-2 py-1 text-right">
                  <Placeholder loading={isLoading}>{customerPhone}</Placeholder>
                </td>
                <td className="px-2 py-1 min-w-[8em]">
                  <Placeholder loading={isLoading}>
                    <DateDisplay format={DEALER_DATE_TIME}>
                      {dateCreated}
                    </DateDisplay>
                  </Placeholder>
                </td>
                <td className="px-2 py-1 text-right">
                  <Placeholder loading={isLoading}>
                    <PriceDisplay>{quoteTotal}</PriceDisplay>
                  </Placeholder>
                </td>
                <td className="px-2 py-1">
                  <Placeholder loading={isLoading}>{customerNotes}</Placeholder>
                </td>
                <td className="px-2 py-1">
                  <Placeholder loading={isLoading}>{orderPrinted}</Placeholder>
                </td>
                <td className="px-2 py-1">
                  <Placeholder loading={isLoading}>{priceMatch}</Placeholder>
                </td>
                <td className="px-2 py-1">
                  <Placeholder loading={isLoading}>{status}</Placeholder>
                </td>
                <td className="px-2 py-1">
                  <Placeholder loading={isLoading}>
                    {viewQuotes && (
                      <a
                        className="underline text-primary"
                        href={removeHostFromUrl(viewQuotes)}
                        rel="noreferrer"
                        target="_blank"
                      >
                        {t("quoteReport.details")}
                      </a>
                    )}
                  </Placeholder>
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
      {data.length === 0 && (
        <NoData className="max-w-[12em] mx-auto my-8">
          {t("quoteReport.noData")}
        </NoData>
      )}
    </>
  );
};
